import { render, staticRenderFns } from "./ReviewApplied.vue?vue&type=template&id=90a3ff8c&scoped=true&"
import script from "./ReviewApplied.vue?vue&type=script&lang=ts&"
export * from "./ReviewApplied.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewApplied.vue?vue&type=style&index=0&id=90a3ff8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a3ff8c",
  null
  
)

export default component.exports